// Mutations
export const SETUSER = 'SETUSER';
export const SETISAUTHENTICATED = 'SETISAUTHENTICATED';
export const SETLASTAUTHERRORMSG = 'SETLASTAUTHERRORMSG';

// Actions
export const USERLOGIN = 'USERLOGIN';
export const USERLOGOUT = 'USERLOGOUT';
export const USERAUTOLOGIN = 'USERAUTOLOGIN';
export const FAILAUTHENTICATION = 'FAILAUTHENTICATION';

import db from '../../firebase/firebase'
import router from '../../router/router'
import { BINDGUILDS, UNBINDGUILDS } from './guilds'
import { UNBINDDESTINATIONS } from './destinations'
import { UNBINDPROPERTIES } from './properties'
import { UNBINDLOCKOUTS } from './lockouts'
import { UNBINDLOCKOUTCONTENT } from './lockouts'

export default {
  state: () => ({
    user: null,
    isAuthenticated: false,
    lastautherrormsg: '',
  }),

  getters: {
    userDateTime: ( state ) => ( date ) => {

      let locale = 'en-US'
      if( state.user.locale ) {
        locale = state.user.locale
      }
      else if ( navigator.languages && navigator.languages.length ) {
        locale = navigator.languages[0];
      }
      else {
        locale = navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';
      }

      return date.toLocaleString( locale )
    },
  },

  mutations: {
    [SETUSER] ( state, user ) {
      state.user = user;
      state.isAuthenticated = user != null
    },
    [SETLASTAUTHERRORMSG] ( state, errormsg ) {
      state.lastautherrormsg = errormsg
    },
  },

  actions: {

    async [USERLOGIN]( { commit, dispatch }, user ) {

      try {
        // Get extra user-data from Firebase
        let snapshot = await db.ref( 'users/' + user.uid ).get()

        let data = snapshot.val()
        if( data ) {
          let displayName = data.displayName
          if( !displayName ) {
            let tokens = user.email.split( '@' )
            tokens[0] = tokens[0].substr(0,3) + '*********'
            displayName = tokens.join( '@' )
          }
          user.myDisplayName = displayName
          user.admin = data.admin
          user.guilds = data.guilds
          user.locale = data.locale
        }

        commit( SETUSER, user );

        // Add the user to the database
        if( !data ) {
          db.ref( 'users/' + user.uid ).set( { email: user.email } );
        }

        // Fill the Guilds dropdown
        dispatch( BINDGUILDS )

        router.push('/roster');

      } catch ( error ) {
        dispatch( FAILAUTHENTICATION, error )
      }
    },

    async [USERLOGOUT]( { commit, dispatch } ) {
      // Clear the Guilds dropdown
      await dispatch( UNBINDLOCKOUTCONTENT )
      await dispatch( UNBINDLOCKOUTS )
      await dispatch( UNBINDPROPERTIES )
      await dispatch( UNBINDDESTINATIONS )
      await dispatch( UNBINDGUILDS )

      dispatch( 'resetState' )

      commit( SETUSER, null );

      router.push('/');
    },

    [FAILAUTHENTICATION] ( { commit }, error ) {
      commit( SETUSER, null );
      commit( SETLASTAUTHERRORMSG, error.message );
    },

  },
}